import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-public-form',
  templateUrl: './confirmation-public-form.component.html',
  styleUrls: ['./confirmation-public-form.component.css']
})
export class ConfirmationPublicFormComponent implements OnInit {
  success = '';
  constructor(private route: ActivatedRoute, private router: Router) { 

    this.success = this.route.snapshot.paramMap.get('status');
  }

  ngOnInit() {
    if(!(this.success === 'success' ||  this.success === 'fail')){
      this.router.navigate(['/404']);
    }
  }

}
